import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ErpWorkflowHistoryComponent } from './erpworkflowhistory.component';

@Component({
    selector: 'erp-workflow-historytest',
    templateUrl: './erpworkflowhistorytest.component.html'
})
export class ErpWorkflowHistoryTestComponent implements OnInit {
    @ViewChild(ErpWorkflowHistoryComponent) workflowComponent!: ErpWorkflowHistoryComponent;
    attributeSelectForm = this.formBuilder.group({
        processTypeFC: '',
        processIdFC: ''
    });
    selectedProcessType!: string;
    selectedProcessId!: number;

    constructor(
        private formBuilder: FormBuilder
    ) { }

    load(): void {
        this.workflowComponent.clearHistory();
        this.workflowComponent.processId = this.selectedProcessId;
        this.workflowComponent.processType = this.selectedProcessType;
        this.workflowComponent.loadHistory();
    }

    ngOnInit(): void {
    }

}
